export default __webpack_public_path__ + "static/media/elePerson1-1.b6766f57.png";